import { Card } from './card';
import { Rank, Suit } from './definitions';
import { getRandomValue } from './random';
export function compareRank(l, r, aceHigh = false) {
    return getRankValue(l, aceHigh) - getRankValue(r, aceHigh);
}
export function compareSuit(l, r) {
    return getSuitValue(l) - getSuitValue(r);
}
export function getSuitValue(suit) {
    switch (suit) {
        case Suit.Clubs:
            return 1;
        case Suit.Diamonds:
            return 2;
        case Suit.Hearts:
            return 0;
        case Suit.Spades:
            return 3;
    }
}
export function getSuit(card) {
    const suit = card.charAt(card.length - 1).toUpperCase();
    switch (suit) {
        case 'H':
            return Suit.Hearts;
        case 'D':
            return Suit.Diamonds;
        case 'S':
            return Suit.Spades;
        case 'C':
            return Suit.Clubs;
    }
    throw new Error(`Invalid suit for card: '${suit}'`);
}
export function getRank(card) {
    const rank = card.substring(0, card.length - 1);
    return rank;
}
export function getRankValue(rank, aceHigh = false) {
    switch (rank) {
        case Rank.Ace:
            return aceHigh ? 14 : 1;
        case Rank.King:
            return 13;
        case Rank.Queen:
            return 12;
        case Rank.Jack:
            return 11;
        default:
            const val = parseInt(rank);
            return val;
    }
}
const Suits = ['S', 'C', 'D', 'H'];
export function createDeck() {
    const deck = [];
    for (const suit of Suits) {
        for (let x = 1; x <= 13; ++x) {
            let rank;
            switch (x) {
                case 1:
                    rank = 'A';
                    break;
                case 11:
                    rank = 'J';
                    break;
                case 12:
                    rank = 'Q';
                    break;
                case 13:
                    rank = 'K';
                    break;
                default:
                    rank = x;
                    break;
            }
            deck.push(Card.fromString(`${rank}${suit}`));
        }
    }
    return deck;
}
export function getRankByValue(value) {
    switch (value) {
        case 1:
            return Rank.Ace;
        case 2:
            return Rank.Two;
        case 3:
            return Rank.Three;
        case 4:
            return Rank.Four;
        case 5:
            return Rank.Five;
        case 6:
            return Rank.Six;
        case 7:
            return Rank.Seven;
        case 8:
            return Rank.Eight;
        case 9:
            return Rank.Nine;
        case 10:
            return Rank.Ten;
        case 11:
            return Rank.Jack;
        case 12:
            return Rank.Queen;
        case 13:
            return Rank.King;
        case 14:
            return Rank.Ace;
        default:
            throw new Error(`Invalid Rank value ${value}`);
    }
}
export function shuffle(inArray) {
    if (!Array.isArray(inArray)) {
        return inArray;
    }
    for (let i = inArray.length - 1; i > 0; --i) {
        const j = Math.floor(getRandomValue() * i);
        const temp = inArray[i];
        inArray[i] = inArray[j];
        inArray[j] = temp;
    }
}
export function deepCopy(inObject) {
    if (typeof inObject !== 'object' || inObject === null) {
        return inObject; // Return the value if inObject is not an object
    }
    // Create an array or object to hold the values
    const outObject = Array.isArray(inObject) ? [] : {};
    for (const key of Object.keys(inObject)) {
        const value = inObject[key];
        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = deepCopy(value);
    }
    return outObject;
}
export function getCardsInHand(cards, position) {
    return cards.filter((c) => c.pile === `hand${position}`);
}
export function getCardByID(cards, id) {
    const card = cards.filter((c) => c.id === id)[0];
    return card;
}
//# sourceMappingURL=data:application/json;base64,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